import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddGoodsItem } from '../api/addGoodsItem';
import { Fields } from '../hooks/useGoodsItemForm';

import { GoodsItemForm } from './GoodsItemForm';

type AddModalProps = {
  initialValues: Fields;
};

export const AddModal = NiceModal.create(({ initialValues }: AddModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddGoodsItem({
    department: initialValues.department,
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Новый товар"
    >
      <GoodsItemForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
